import { useQuery } from "@tanstack/react-query";
import { useAuth, authorizedAxios } from "@moonscape/shared";

export const useVerifyCheckout = ({
  sessionId,
  onSuccess,
  onError,
}: {
  sessionId: string;
  onSuccess?: () => void;
  onError?: (err: unknown) => void;
}) => {
  const { getToken } = useAuth();

  const { refetch, isLoading, error, data } = useQuery({
    queryKey: ["verifyCheckout"],
    queryFn: async () => {
      const token = await getToken();
      const response = await authorizedAxios(token).get(
        `/order/success?sessionId=${sessionId}`
      );
      return response.data;
    },
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (err) => {
      onError?.(err);
      console.error("[verifyCheckout] Error", err);
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  return {
    refetch: refetch,
    isQueryloading: isLoading,
    error: error,
    data: data,
  };
};
